// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3pc_m","file":"styles_file__113h-"};